import { groupFromDto } from '../../group.dto';

export function azureDomainsFromDto(domains) {
    return domains.map((domain) => ({...domain, groups: domain.groups.map((group) => ({...group, type:'AZURE_GROUP'}))}));
}

export function scimDomainsFromDto(domains) {
    return domains.map((domain) => ({...domain, groups: domain.groups}));
}

export function domainsFromDto(domains) {
    return domains.map((domain) => ({...domain, groups: groupsFromDto(domain.groups)}));
}

function groupsFromDto(dto) {
    const groups = dto.map(groupFromDto).sort((a, b) => a.cname.localeCompare(b.cname));
    const domains = groups.filter(({type}) => type === 'AD_DOMAIN');
    const ous = groups.filter(({type}) => type === 'AD_OU');
    const children = (ou) => groups.filter((g) => g.parentName === ou.cname);
    return domains.concat(...ous.map((ou) => [ou, ...children(ou)]));
}

export function isAzure(directory) {
    return directory.type === 'AZURE';
}

export function isSCIM(directory) {
    return directory.type === 'SCIM';
}

export function emptyDomainListCheck(directory, domains) {
	if (domains == null || domains.length == 0) {
        return [{
            domainName: directory.name,
            isRoot: false,
            groups: []
        }];
    } else {
        return domains;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/directory.functions.js